import '@/user/common';
import $ from 'jquery';
import { mapSetting, tabSetting } from '@/shared/page/map/_index';

const type = $('.map').data('type'); // hall or salon
const $hallMap = $('#hall_map'); // 会場地図要素
const $salonMap = $('#salon_map'); // サロン地図要素

$(() => {
    // 初期表示
    mapSetting(type, $hallMap, $salonMap);
    tabSetting(type, $hallMap, $salonMap);

    // タブ切り替えた
    $('#tabs--map li').on('click', e => {
        const clickType = e.currentTarget.dataset.click_type;
        mapSetting(clickType, $hallMap, $salonMap);
        tabSetting(clickType, $hallMap, $salonMap);
    });

    // サロンのページ内スクロール
    $('.map-navi__link').on('click', e => {
        const salonId = e.currentTarget.dataset.salon_id; // 選択されたサロンID
        const headerHeight = $('.l-header').outerHeight(true); // ヘッダーの高さ
        const salonElementPosition = $(`#${salonId}`).offset().top; // 選択されたサロンの位置
        const scrollPosition = salonElementPosition - headerHeight - 50; // スクロール位置（要素 - ヘッダー - 50px)
        scrollTo(0, scrollPosition);
    });
});
